/* eslint-disable */
import saveStoreDraft from "../../../utils/saveStoreDraft";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { applyStoreDraft } from "../../../redux/store/store";
import { doc } from "firebase/firestore";
import { db } from "../../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Check, RefreshCw, Info, X, Globe, MapPin, Power } from "lucide-react";
import apicache from "../../clearCach/clear";
import { useTranslation } from "react-i18next";

export default function ActivationCountrySelector({ close }) {
    const store = useSelector((state) => state.StoreReducer);
    const dispatch = useDispatch();
    const MySwal = withReactContent(Swal);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const { t, i18n } = useTranslation();
    const account = useSelector((state) => state.AccountReducer);

    // قائمة الدول المتاحة
    const allCountries = [
        { code: "DZ", name: t("countries.DZ"), flag: "🇩🇿" },
        { code: "MA", name: t("countries.MA"), flag: "🇲🇦" },
        { code: "TN", name: t("countries.TN"), flag: "🇹🇳" },
        { code: "SA", name: t("countries.SA"), flag: "🇸🇦" },
        { code: "AE", name: t("countries.AE"), flag: "🇦🇪" },
        { code: "KW", name: t("countries.KW"), flag: "🇰🇼" },
        { code: "QA", name: t("countries.QA"), flag: "🇶🇦" },
        { code: "BH", name: t("countries.BH"), flag: "🇧🇭" },
        { code: "OM", name: t("countries.OM"), flag: "🇴🇲" },
        { code: "EG", name: t("countries.EG"), flag: "🇪🇬" },
        { code: "JO", name: t("countries.JO"), flag: "🇯🇴" },
        { code: "LB", name: t("countries.LB"), flag: "🇱🇧" },
    ];
      const isRTL = i18n.dir() === "rtl";
    // الحالة الأولية من البيانات المخزنة
    useEffect(() => {
        if (store) {
            const hasCountrySelection = store.countrySelection && store.countrySelection.length > 0;
            const isEnabled = store.countrySelectorEnabled !== false && hasCountrySelection;

            if (store.countrySelection) {
                setSelectedCountries(store.countrySelection);
            } else {
                setSelectedCountries([]);
            }

            setIsActive(isEnabled);
            setServiceEnabled(isEnabled);
        }
    }, [store]);

    const [selectedCountries, setSelectedCountries] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [serviceEnabled, setServiceEnabled] = useState(false);

    const showAlert = (icon, title, text) => {
        return Swal.fire({
            icon,
            title,
            text,
            confirmButtonText: t("ship.ok"),
            confirmButtonColor: "rgb(141, 93, 167)",
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: true,
            backdrop: `
        rgba(0,0,0,0.7)
      `,
            position: "center",
            customClass: {
                popup: "swal-popup-on-top",
                backdrop: "swal-backdrop-on-top",
                container: "swal-container-on-top",
            },
            willOpen: () => {
                document.querySelector(".swal2-container").style.zIndex = "9999999999";
            },
        });
    };

    // تصفية الدول حسب البحث
    const filteredCountries = allCountries.filter(
        (country) =>
            country.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            country.code.toLowerCase().includes(searchTerm.toLowerCase())
    );

    // تبديل اختيار دولة
    const toggleCountry = (countryCode) => {
        setSelectedCountries((prev) =>
            prev.includes(countryCode)
                ? prev.filter((code) => code !== countryCode)
                : [...prev, countryCode]
        );
    };

    // اختيار كل الدول
    const selectAllCountries = () => {
        setSelectedCountries(allCountries.map((country) => country.code));
    };

    // إلغاء اختيار كل الدول
    const deselectAllCountries = () => {
        setSelectedCountries([]);
    };

    // حفظ التحديدات في Firebase
    const saveToFirebase = async (countries, enabled) => {
        setSaving(true);
        try {
            const updatedData = {
                ...store,
                countrySelection: countries,
                countrySelectorEnabled: enabled,
                countrySelectorLastUpdate: new Date().toISOString()
            };

            await saveStoreDraft(doc(db, "store", store.id), store, updatedData);
            dispatch(applyStoreDraft(store, updatedData));
            apicache(account, null); // تحديث الكاش

            setSaving(false);
            return true;
        } catch (error) {
            setSaving(false);
            console.error("Error saving country selection to Firebase:", error);
            return false;
        }
    };

    // معالجة تفعيل/إلغاء التفعيل
    const handleToggleActivation = async () => {
        if (isActive) {
            // إلغاء التفعيل
            setLoading(true);

            // عرض تأكيد للإلغاء
            const result = await Swal.fire({
                title: t("cashBack.swal.deleteConfirm.title"),
                text: t("servicePageActivation.countrySelector.uiTexts.alerts.deactivationText"),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: t("activationCompanies.alerts.deactivateConfirm.confirmText"),
                cancelButtonText: t("annule"),
                reverseButtons: true
            });

            if (result.isConfirmed) {
                // حفظ حالة الإلغاء في Firebase
                const success = await saveToFirebase([], false);

                if (success) {
                    setSelectedCountries([]);
                    setIsActive(false);
                    setServiceEnabled(false);

                    await showAlert(
                        "success",
                        "تم إلغاء التفعيل بنجاح",
                        "المتجر الآن متاح في جميع الدول"
                    );
                } else {
                    await showAlert(
                        "error",
                        "حدث خطأ",
                        "لم يتم حفظ التغييرات، يرجى المحاولة مرة أخرى"
                    );
                }
            }
            setLoading(false);
        } else {
            // تفعيل الميزة
            setLoading(true);

            // حفظ حالة التفعيل في Firebase
            const success = await saveToFirebase(selectedCountries, true);

            if (success) {
                setIsActive(true);
                setServiceEnabled(true);

                await showAlert(
                    "success",
                    "تم تفعيل الميزة بنجاح",
                    `تم تحديد ${selectedCountries.length} دولة للظهور`
                );
            } else {
                await showAlert(
                    "error",
                    "حدث خطأ",
                    "لم يتم حفظ التغييرات، يرجى المحاولة مرة أخرى"
                );
            }
            setLoading(false);
        }
    };

    // حفظ التحديدات
    const handleSaveSelections = async (e) => {
        if (e) e.preventDefault();

        if (selectedCountries.length === 0) {
            await showAlert(
                "warning",
                "يرجى اختيار دولة واحدة على الأقل",
                "يجب تحديد دولة واحدة على الأقل لتفعيل ميزة تحديد الدول"
            );
            return;
        }

        setLoading(true);

        // حفظ التحديدات في Firebase
        const success = await saveToFirebase(selectedCountries, true);

        if (success) {
            setIsActive(true);
            setServiceEnabled(true);

            await showAlert(
                "success",
                "تم حفظ التحديدات بنجاح",
                `تم تحديد ${selectedCountries.length} دولة للظهور`
            );

            if (close) close();
        } else {
            await showAlert(
                "error",
                "حدث خطأ أثناء حفظ الإعدادات",
                "يرجى المحاولة مرة أخرى"
            );
        }
        setLoading(false);
    };

    // إعادة التعيين للقيم الافتراضية
    const handleReset = async () => {
        const result = await Swal.fire({
            title: t("servicePageActivation.countrySelector.uiTexts.alerts.resetTitle"),
            text: t("servicePageActivation.countrySelector.uiTexts.alerts.resetText"),
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#9e68ba',
            cancelButtonColor: '#6b7280',
            confirmButtonText: t("servicePageActivation.orderMessages.alerts.resetMessage.confirm"),
            cancelButtonText: t("annule"),
            reverseButtons: true
        });

        if (result.isConfirmed) {
            setSelectedCountries(["SA", "AE", "KW"]);
            setSearchTerm("");

            // إذا كانت الميزة مفعلة، احفظ التغييرات تلقائياً
            if (isActive) {
                await handleSaveSelections();
            }
        }
    };

    // زر الحفظ العام
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isActive) {
            // إذا كانت الميزة مفعلة، احفظ التحديدات
            await handleSaveSelections(e);
        } else {
            // إذا كانت معطلة، فعّل الميزة
            await handleToggleActivation();
        }
    };

    return (
        <div className="min-h-[400px] h-fit p-6 dark:!bg-[#181919] dark:text-gray-100 dark:!border-gray-700" dir={isRTL ? "rtl" : "ltr"}>
            {/* Page Header */}
            <div className="mb-6">
                <h1 className="text-xl font-bold text-[#9e68ba] dark:text-purple-400 mb-2">
                    {t("servicePageActivation.countrySelector.title")}
                </h1>
                <p className="text-gray-600 dark:text-gray-400">
                    {t("servicePageActivation.countrySelector.uiTexts.pageDescription")}
                </p>
            </div>

            {/* Service Status Indicator */}
            <div
                className={`mb-6 p-4 rounded-lg ${isActive && selectedCountries.length > 0
                        ? "bg-green-50 dark:bg-green-900/30 border border-green-200 dark:!border-green-800"
                        : "bg-gray-50 dark:bg-gray-800/50 border border-gray-200 dark:!border-gray-700"
                    }`}
            >
                <div className="flex justify-between items-center">
                    <div className="flex items-center">
                        <div
                            className={`w-3 h-3 rounded-full mr-2 ${isActive && selectedCountries.length > 0
                                    ? "bg-green-500 dark:bg-green-400 animate-pulse"
                                    : "bg-gray-400 dark:bg-gray-500"
                                }`}
                        ></div>
                        <span
                            className={`font-medium ${isActive && selectedCountries.length > 0
                                    ? "text-green-700 dark:text-green-300"
                                    : "text-gray-700 dark:text-gray-300"
                                }`}
                        >
                            {isActive && selectedCountries.length > 0
                                ? t("servicePageActivation.countrySelector.uiTexts.serviceStatus.active")
                                : t("servicePageActivation.countrySelector.uiTexts.serviceStatus.inactive")}
                        </span>
                        {saving && (
                            <span className="text-xs text-blue-600 dark:text-blue-400 mr-3 animate-pulse">
                                {t("servicePageActivation.countrySelector.uiTexts.savingIndicator")}
                            </span>
                        )}
                    </div>

                    <button
                        type="button"
                        onClick={handleToggleActivation}
                        disabled={loading || saving}
                        className={`px-4 py-2 text-sm rounded-lg font-medium transition-colors flex items-center ${isActive && selectedCountries.length > 0
                                ? "bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 hover:bg-red-200 dark:hover:bg-red-800/50"
                                : "bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 hover:bg-green-200 dark:hover:bg-green-800/50"
                            } ${loading || saving ? 'opacity-50 cursor-not-allowed' : ''}`}
                    >
                        <Power size={16} className="ml-2" />
                        {isActive && selectedCountries.length > 0 ? t("servicePageActivation.countrySelector.uiTexts.toggleButton.deactivate") : t("servicePageActivation.countrySelector.uiTexts.toggleButton.activate")}
                    </button>
                </div>

                {isActive && selectedCountries.length > 0 && (
                    <div className="mt-3 text-sm text-green-600 dark:text-green-400">
                        <Globe size={16} className="inline ml-1" />
                        {t("servicePageActivation.countrySelector.uiTexts.statusMessages.active")}
                    </div>
                )}
                {!isActive && (
                    <div className="mt-3 text-sm text-gray-600 dark:text-gray-400">
                        <Globe size={16} className="inline ml-1" />
                        {t("servicePageActivation.countrySelector.uiTexts.statusMessages.inactive")}
                    </div>
                )}
            </div>

            {/* Activation Form */}
            <div className="bg-white dark:!bg-[#181919] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-gray-700 p-6 mb-6">
                <form onSubmit={handleSubmit}>
                    <div className="mb-6">
                        <h3 className="text-lg font-semibold text-[#9e68ba] dark:text-purple-400 mb-4">
                            {isActive ? t("servicePageActivation.countrySelector.uiTexts.formTitles.active") : t("servicePageActivation.countrySelector.uiTexts.formTitles.inactive")}
                        </h3>

                        {/* Search and Controls */}
                        <div className="mb-6">
                            <div className="flex justify-between items-center mb-4">
                                <h4 className="text-md font-semibold text-gray-800 dark:!text-gray-200">
                                    {t("servicePageActivation.countrySelector.uiTexts.selectedCountries", { count: selectedCountries.length })}
                                </h4>
                                <div className="flex gap-2">
                                    <button
                                        type="button"
                                        onClick={selectAllCountries}
                                        disabled={loading || saving}
                                        className="px-4 py-2 text-sm bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-800/50 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {t("servicePageActivation.countrySelector.uiTexts.buttons.selectAll")}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={deselectAllCountries}
                                        disabled={loading || saving}
                                        className="px-4 py-2 text-sm bg-gray-50 dark:bg-gray-700 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-600 rounded-lg font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                    >
                                        {t("servicePageActivation.countrySelector.uiTexts.buttons.deselectAll")}
                                    </button>
                                </div>
                            </div>

                            {/* Search Input */}
                            <div className="relative mb-4">
                                <input
                                    type="text"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    placeholder={t("servicePageActivation.countrySelector.uiTexts.searchPlaceholder")}
                                    className="w-full px-4 py-3 pr-12 border border-gray-300 dark:!border-gray-600 rounded-lg focus:ring-2 focus:ring-purple-500 dark:focus:ring-purple-400 focus:border-transparent outline-none transition bg-white dark:!bg-gray-700 text-gray-900 dark:!text-gray-100 placeholder-gray-500 dark:placeholder-gray-400"
                                    dir="rtl"
                                    disabled={loading || saving}
                                />
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5 absolute left-3 top-3.5 text-gray-400 dark:!text-gray-500"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                    />
                                </svg>
                            </div>

                            {/* Countries List */}
                            <div className="max-h-60 overflow-y-auto border border-gray-200 dark:!border-gray-700 rounded-lg bg-white dark:!bg-gray-800">
                                {filteredCountries.length > 0 ? (
                                    <div className="divide-y divide-gray-100 dark:divide-gray-700">
                                        {filteredCountries.map((country) => {
                                            const isSelected = selectedCountries.includes(country.code);
                                            return (
                                                <div
                                                    key={country.code}
                                                    onClick={() => !loading && !saving && toggleCountry(country.code)}
                                                    className={`flex items-center justify-between p-3 cursor-pointer transition-colors ${isSelected
                                                            ? "bg-purple-50 dark:bg-purple-900/30 text-gray-800 dark:text-gray-200"
                                                            : "hover:bg-gray-50 dark:hover:bg-gray-700/50 text-gray-800 dark:text-gray-200"
                                                        } ${loading || saving ? 'opacity-70 cursor-not-allowed' : ''}`}
                                                >
                                                    <div className="flex items-center">
                                                        <span className="text-2xl ml-3">{country.flag}</span>
                                                        <div>
                                                            <span className="mx-2 font-medium">
                                                                {country.name}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center">
                                                        {isSelected ? (
                                                            <div className="w-5 h-5 bg-purple-600 dark:bg-purple-500 rounded-full flex items-center justify-center">
                                                                <svg
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                    className="h-3 w-3 text-white"
                                                                    viewBox="0 0 20 20"
                                                                    fill="currentColor"
                                                                >
                                                                    <path
                                                                        fillRule="evenodd"
                                                                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                                        clipRule="evenodd"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        ) : (
                                                            <div className="w-5 h-5 border-2 border-gray-300 dark:!border-gray-500 rounded-full"></div>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className="p-8 text-center text-gray-500 dark:!text-gray-400">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-12 w-12 mx-auto text-gray-300 dark:text-gray-600 mb-3"
                                            fill="none"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={1.5}
                                                d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                            />
                                        </svg>
                                        {t("servicePageActivation.countrySelector.uiTexts.noResults")}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Selected Countries Preview */}
                        <div className="mb-6">
                            <h5 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 flex items-center">
                                <MapPin size={16} className="ml-1" />
                                {t("servicePageActivation.countrySelector.uiTexts.currentlySelected")}
                            </h5>
                            {selectedCountries.length > 0 ? (
                                <div className="flex flex-wrap gap-2">
                                    {selectedCountries.map((code) => {
                                        const country = allCountries.find((c) => c.code === code);
                                        return country ? (
                                            <div
                                                key={code}
                                                className="flex items-center bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300 px-3 py-1.5 rounded-full"
                                            >
                                                <span className="ml-2">{country.flag}</span>
                                                <span>{country.name}</span>
                                                <button
                                                    type="button"
                                                    onClick={() => !loading && !saving && toggleCountry(code)}
                                                    disabled={loading || saving}
                                                    className="mr-2 text-purple-600 dark:text-purple-400 hover:text-purple-800 dark:hover:text-purple-300 disabled:opacity-50 disabled:cursor-not-allowed"
                                                >
                                                    <X size={14} />
                                                </button>
                                            </div>
                                        ) : null;
                                    })}
                                </div>
                            ) : (
                                <div className="text-center py-4 text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-700/50 rounded-lg">
                                    {t("servicePageActivation.countrySelector.uiTexts.noCountriesSelected")}
                                </div>
                            )}
                        </div>

                        {/* Tips Section */}
                        <div className="bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-100 dark:!border-blue-800/30 mb-6">
                            <h4 className="font-medium text-lg text-blue-800 dark:text-blue-300 mb-2 flex items-center">
                                <Info size={18} className="ml-2" />
                                {t("servicePageActivation.countrySelector.uiTexts.tipsSection.title")}
                            </h4>
                            <ul className="text-sm text-gray-700 dark:text-gray-300 space-y-2">
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                                    <span>
                                        {t("servicePageActivation.countrySelector.uiTexts.tipsSection.marketTarget")}
                                    </span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                                    <span>
                                        {t("servicePageActivation.countrySelector.uiTexts.tipsSection.localLaws")}
                                    </span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                                    <span>
                                        {t("servicePageActivation.countrySelector.uiTexts.tipsSection.shippingService")}
                                    </span>
                                </li>
                                <li className="flex items-start">
                                    <span className="text-blue-600 dark:text-blue-400 ml-2">•</span>
                                    <span>
                                        {t("servicePageActivation.countrySelector.uiTexts.tipsSection.technicalSupport")}
                                    </span>
                                </li>
                            </ul>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex justify-between gap-3">
                            <div className="flex gap-3">
                                <button
                                    type="button"
                                    onClick={handleReset}
                                    disabled={loading || saving}
                                    className="px-4 py-2.5 border border-gray-300 dark:!border-gray-600 text-gray-700 dark:text-gray-300 font-medium rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                                >
                                    {t("servicePageActivation.countrySelector.uiTexts.alerts.resetTitle")}
                                </button>
                            </div>

                            <button
                                type="submit"
                                disabled={loading || saving}
                                className={`px-6 py-2.5 ${isActive
                                        ? "bg-[#9e68ba] dark:bg-purple-600 hover:bg-[#8a5ca5] dark:hover:bg-purple-700"
                                        : "bg-green-600 dark:bg-green-700 hover:bg-green-700 dark:hover:bg-green-600"
                                    } text-white font-medium rounded-lg transition-colors flex items-center disabled:opacity-50 disabled:cursor-not-allowed`}
                            >
                                {loading || saving ? (
                                    <>
                                        <RefreshCw className="animate-spin ml-2" size={18} />
                                        {saving ? t("servicePageActivation.countrySelector.uiTexts.savingIndicator") : t("servicePageActivation.countrySelector.uiTexts.processingIndicator")}
                                    </>
                                ) : (
                                    <>
                                        <Check className="ml-2" size={18} />
                                        {isActive ? t("servicePageActivation.countrySelector.uiTexts.buttons.save") : t("servicePageActivation.countrySelector.uiTexts.buttons.activateWithSelection")}
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            {/* Service Status Information */}
            <div className="text-xs text-gray-500 dark:text-gray-400 text-center">
                {store?.countrySelectorLastUpdate && (
                    <p>
                        {t("servicePageActivation.countrySelector.uiTexts.lastUpdate")} {new Date(store.countrySelectorLastUpdate).toLocaleString('fr-FR')}
                    </p>
                )}
            </div>
        </div>
    );
}